import Vue from "vue";
import VueRouter from "vue-router";
// import LoginView from '../views/LoginView.vue'
// import SignUpView from '../views/SignUpView.vue'
// import GeneratorView from '../views/GeneratorView.vue'
// import GeneratorEnglishView from '../views/GeneratorEnglishView.vue'

// import GeneratorDinoView from '../views/GeneratorDinoView.vue'
// import GeneratorPrincessView from '../views/GeneratorPrincessView.vue'
// import GeneratorCarsView from '../views/GeneratorCarsView.vue'
// import GeneratorBabyView from '../views/GeneratorBabyView.vue'
// import GeneratorPeterpanView from '../views/GeneratorPeterpanView.vue'
// import GeneratorHanselView from '../views/GeneratorHanselView.vue'
// import GeneratorMermaidView from '../views/GeneratorMermaidView.vue'
import AvatarGeneratorView from "../views/AvatarGeneratorView.vue";

Vue.use(VueRouter);

const routes = [
    // {
    //     path: "/",
    //     name: "GeneratorDinoView",
    //     component: GeneratorDinoView,
    //     meta: { title: "えほんインク" },
    // },    
    {
        path: "/",
        name: "AvatarGeneratorView",
        component: AvatarGeneratorView,
        meta: { title: "えほんインク" },
    },
    // {
    //   path: '/',
    //   name: 'LoginView',
    //   component: LoginView,
    //   meta: { title: 'えほんインク'}
    // },
    // {
    //   path: '/login',
    //   name: 'LoginView',
    //   component: LoginView,
    //   meta: { title: 'えほんインク'}
    // },
    // {
    //   path: '/signup',
    //   name: 'SignUpView',
    //   component: SignUpView,
    //   meta: { title: 'えほんインク'}
    // },
    // {
    //   path: '/dino',
    //   name: 'GeneratorDinoView',
    //   component: GeneratorDinoView,
    //   meta: { title: 'えほんインク'}
    // },
    // {
    //   path: '/princess',
    //   name: 'GeneratorPrincessView',
    //   component: GeneratorPrincessView,
    //   meta: { title: 'えほんインク'}
    // },
    // {
    //   path: '/cars',
    //   name: 'GeneratorCarsView',
    //   component: GeneratorCarsView,
    //   meta: { title: 'えほんインク'}
    // },
    // {
    //   path: '/baby',
    //   name: 'GeneratorBabyView',
    //   component: GeneratorBabyView,
    //   meta: { title: 'えほんインク'}
    // },
    // {
    //     path: "/peterpan",
    //     name: "GeneratorPeterpanView",
    //     component: GeneratorPeterpanView,
    //     meta: { title: "えほんインク" },
    // },
    // {
    //   path: '/mermaid',
    //   name: 'GeneratorMermaidView',
    //   component: GeneratorMermaidView,
    //   meta: { title: 'えほんインク'}
    // },
    // {
    //   path: '/hansel',
    //   name: 'GeneratorHanselView',
    //   component: GeneratorHanselView,
    //   meta: { title: 'えほんインク'}
    // },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

// router.beforeEach((to, from, next) => {
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
//   if (requiresAuth) {
//       const user = sessionStorage.getItem('user')
//       console.log(JSON.parse(user))
//       if (!user) {
//           next({
//               path: '/login',
//               query: {redirect: to.fullPath}
//           })
//       } else {
//           next()
//       }
//   } else {
//       next()
//   }
// })

export default router;

//vue create vue-chat
//cd vue-chat
//vue add vuetify
//vue add router
//npm install firebase@8.8.0
//npm install @mdi/font -D
